import { useIntl } from 'react-intl';
import React from 'react';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { profileMessages } from 'src/features/profile/utils';
import { useTitleStore } from 'src/stores/useTitleStore';

type ProfileLayoutProps = {
    children: React.ReactNode;
};

const ProfileLayout = ({ children }: ProfileLayoutProps) => {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(profileMessages.title));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <TabRow>
                <Tab to="/profile" end>
                    {formatMessage(profileMessages.details)}
                </Tab>
                <Tab to="/profile/email">{formatMessage(profileMessages.email)}</Tab>
                <Tab to="/profile/password">{formatMessage(profileMessages.password)}</Tab>
                <Tab to="/profile/settings">{formatMessage(profileMessages.settings)}</Tab>
            </TabRow>
            {children}
        </MainLayout>
    );
};

export default ProfileLayout;
